import type { CropMeta } from '../../utils/cropUtils';

interface LiveCropViewProps {
  originalUrl: string;
  crop: CropMeta;
  imgW: number;
  imgH: number;
}

/** Affiche exactement la zone cropée sur l'original (comme l'éditeur admin). */
export function LiveCropView({ originalUrl, crop, imgW, imgH }: LiveCropViewProps) {
  const bgW = (imgW / crop.width) * 100;
  const bgH = (imgH / crop.height) * 100;
  const posX = imgW > crop.width ? (crop.left / (imgW - crop.width)) * 100 : 50;
  const posY = imgH > crop.height ? (crop.top / (imgH - crop.height)) * 100 : 50;

  return (
    <div className="zoom-frame">
      <div
        className="live-crop-view"
        style={{
          backgroundImage: `url(${originalUrl})`,
          backgroundSize: `${bgW}% ${bgH}%`,
          backgroundPosition: `${Number.isFinite(posX) ? posX : 50}% ${Number.isFinite(posY) ? posY : 50}%`,
        }}
        role="img"
        aria-label="Crop preview"
      />
    </div>
  );
}
